<div style="display:show" id="divdata">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'">{{'addEmpType' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'">{{'editEmpType' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'DELETE'">{{'deleteEmpType' | translate}} </h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'code' | translate}}" [(ngModel)]="mgrdata.code"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'name' | translate}}" [(ngModel)]="mgrdata.name"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'nameLocale' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="mgrdata.nameLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>

    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'description' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" placeholder="{{'description' | translate}}"
                   [(ngModel)]="mgrdata.description"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>

    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'descriptionLocale' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" placeholder="{{'descriptionLocale' | translate}}"
                   [(ngModel)]="mgrdata.descriptionLocale"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>

    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'level' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="number" class="form-control" placeholder="{{'level' | translate}}" [(ngModel)]="mgrdata.level"
                   min="1" *ngIf="type != 'DELETE'"
                   onkeypress="return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101">
            <input type="number" class="form-control" placeholder="{{'level' | translate}}" [(ngModel)]="mgrdata.level"
                   min="1" *ngIf="type == 'DELETE'" readonly>
        </div>
    </div>

    <div class="col-lg-8 col-md-3" *ngIf="type == 'DELETE' && empPresent">
        <div class="form-group">
            <label for="mgrLevelModel">{{'altEmpType' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="mgrLevelModel" name="mgrLevelModel"
                   [source]="mgrLevelObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListMgrLevelFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="{{'typeAndChooseEmpType' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event)"
                   max-num-list=5 [value-formatter]="nameValueFormatter" blank-option-text="Select"
                   [accept-user-input]=false
                   [no-match-found-text]="warning">
            <span class="info-text"> {{'selectEmpType' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3">

        <button class="btn btn-primary float-left mt-4" *ngIf="type == 'ADD'" (click)=this.saveDesgData()> {{'add' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" *ngIf="type == 'EDIT'" (click)=this.saveDesgData()>
            {{'updateChanges' | translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" *ngIf="type == 'DELETE'" (click)=this.deleteDesgData()>
            {{'delete'
            | translate}}
        </button>
        <button class="btn btn-secondary float-left mt-4 ml-1" (click)="goToBackPage()"> {{'cancel' | translate}}
        </button>

    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/addMgrLevel.html